<ng-container *ngIf="blob">
    <ngx-extended-pdf-viewer
        [src]="blob"
        [backgroundColor]="'#ffffff'"
        [handTool]="false"
        [logLevel]="0"
        [scrollMode]="1"
        [showDrawEditor]="false"
        [showFindButton]="false"
        [showHandToolButton]="false"
        [showOpenFileButton]="false"
        [showRotateButton]="false"
        [showSecondaryToolbarButton]="false"
        [showSidebarButton]="false"
        [showTextEditor]="false"
        [textLayer]="false"
        [zoom]="'page-fit'"
    >
    </ngx-extended-pdf-viewer>
</ng-container>
